export const initialVehicles = [
  {
    id: 'mzz099',
    name: 'TAXI – MZZ099',
    plate: 'MZZ099',
    type: 'Car',
    icon: '🚕',
    status: 'active',
    seats: '5 seats',
    features: 'Auto, A/C, GPS',
    priceDay: 45,
    confirm: 'manual',
    deposit: 500,
    bookPage: true,
    currentAreaId: 'area-paphos',
    dropoffAreaIds: 'all',
    odometer: 124500,
    motExpiry: '2026-08-15',
  },
  {
    id: 'klm147',
    name: 'MINIBUS – KLM147',
    plate: 'KLM147',
    type: 'Van',
    icon: '🚐',
    status: 'overdue',
    seats: '9 seats',
    features: 'Manual, A/C',
    priceDay: 80,
    confirm: 'manual',
    deposit: 1000,
    bookPage: true,
    currentAreaId: 'area-paphos',
    dropoffAreaIds: 'all',
    odometer: 89200,
    motExpiry: '2027-02-15',
  },
  {
    id: 'nxt987',
    name: 'FORD TRANSIT – NXT987',
    plate: 'NXT987',
    type: 'Van',
    icon: '🚚',
    status: 'available',
    seats: '3 seats',
    features: 'Manual, A/C, Large cargo',
    priceDay: 65,
    confirm: 'auto',
    deposit: 500,
    bookPage: true,
    currentAreaId: 'area-limassol',
    dropoffAreaIds: ['area-limassol', 'area-paphos'],
    odometer: 88900,
    motExpiry: '2026-06-20',
  },
  {
    id: 'nah532',
    name: 'MINI EXCAVATOR – NAH532',
    plate: 'NAH532',
    type: 'Machine',
    icon: '🏗️',
    status: 'booked',
    seats: '1.8T',
    features: 'Diesel, Operator opt.',
    priceDay: 120,
    confirm: 'manual',
    deposit: 800,
    bookPage: true,
    currentAreaId: 'area-paphos',
    dropoffAreaIds: ['area-paphos'],
    odometer: 2880,
    motExpiry: '2026-10-01',
  },
];

export const mapVehiclePositions = {
  mzz099: { x: 310, y: 270, label: 'TAXI MZZ099', icon: '🚕', status: 'active', speed: '32 km/h', heading: 'E' },
  klm147: { x: 480, y: 385, label: 'MINIBUS KLM147', icon: '🚐', status: 'overdue', speed: '0 km/h', heading: '—' },
  nxt987: { x: 190, y: 310, label: 'FORD TRANSIT NXT987', icon: '🚚', status: 'available', speed: '0 km/h', heading: '—' },
  nah532: { x: 650, y: 320, label: 'MINI EXCAVATOR NAH532', icon: '🏗️', status: 'booked', speed: '0 km/h', heading: '—' },
};
